
/*
 * LINKED LETTERS STUDIO
 * Monogram Upgrade Pop-up
 * 15% off Wedding Identities or Branding Add-Ons
 */

(() => {
  const SESSION_KEY = 'lls-monogram-offer-seen';
  const root = window.Shopify?.routes?.root || '/';

  function createPopup() {
    let dialog = document.getElementById('lls-upgrade-dialog');
    if (dialog) return dialog;

    const style = document.createElement('style');

    style.textContent = `
      #lls-upgrade-dialog {
        box-sizing: border-box;
        width: min(460px, calc(100% - 32px));
        max-height: 90dvh;
        overflow-y: auto;
        margin: auto;
        padding: 38px 28px;
        border: 1px solid #dedbd6;
        border-radius: 0;
        background: #fffdf9;
        color: #252525;
        text-align: center;
        box-shadow: 0 15px 60px rgba(0,0,0,.14);
        position: fixed;
      }

      #lls-upgrade-dialog::backdrop {
        background: rgba(0,0,0,.48);
      }

      .lls-offer-x {
        position: absolute;
        top: 12px;
        right: 14px;
        border: none;
        background: transparent;
        color: #252525;
        font-size: 25px;
        line-height: 1;
        font-weight: 300;
        cursor: pointer;
        padding: 6px 10px;
      }

      .lls-offer-eyebrow {
        font-size: 10px;
        letter-spacing: 2px;
        margin-bottom: 22px;
      }

      .lls-offer-heading {
        font-family: Georgia, serif;
        font-size: clamp(27px, 5vw, 37px);
        font-weight: 400;
        line-height: 1.15;
        margin: 0 0 12px;
      }

      .lls-offer-saving {
        font-family: Georgia, serif;
        font-size: 30px;
        margin: 0 0 20px;
      }

      .lls-offer-description {
        font-size: 14px;
        line-height: 1.7;
        margin: 0 0 25px;
      }

      .lls-offer-button {
        display: block;
        padding: 14px 12px;
        margin-bottom: 10px;
        background: #252525;
        color: white;
        text-decoration: none;
        font-size: 11px;
        letter-spacing: 1px;
        text-align: center;
      }

      .lls-offer-button.secondary {
        background: transparent;
        color: #252525;
        border: 1px solid #252525;
      }

      .lls-offer-button:hover {
        opacity: .8;
      }

      .lls-offer-note {
        font-size: 11px;
        line-height: 1.6;
        margin: 20px 0;
        opacity: .75;
      }

      .lls-offer-close {
        border: 0;
        background: transparent;
        color: inherit;
        text-decoration: underline;
        cursor: pointer;
        font-size: 12px;
        padding: 8px;
      }

      @media (max-width: 480px) {
        #lls-upgrade-dialog {
          padding: 35px 20px 28px;
        }

        .lls-offer-saving {
          font-size: 27px;
        }

        .lls-offer-x {
          top: 8px;
          right: 8px;
        }
      }
    `;

    document.head.appendChild(style);

    dialog = document.createElement('dialog');
    dialog.id = 'lls-upgrade-dialog';
    dialog.setAttribute('aria-labelledby', 'lls-offer-title');

    const weddingUrl = `${root}collections/wedding-identities`;
    const brandingUrl = `${root}collections/branding`;

    dialog.innerHTML = `
      <button
        type="button"
        class="lls-offer-x"
        aria-label="Close offer"
      >&times;</button>

      <div class="lls-offer-eyebrow">
        LINKED LETTERS STUDIO
      </div>

      <h2 class="lls-offer-heading" id="lls-offer-title">
        Complete your identity.
      </h2>

      <div class="lls-offer-saving">
        Enjoy 15% Off
      </div>

      <p class="lls-offer-description">
        Your monogram unlocks an exclusive 15% saving
        on a Wedding Identity or Branding Add-On
        when purchased together.
      </p>

      <a class="lls-offer-button" href="${weddingUrl}">
        EXPLORE WEDDING IDENTITIES
      </a>

      <a class="lls-offer-button secondary" href="${brandingUrl}">
        EXPLORE BRANDING ADD-ONS
      </a>

      <p class="lls-offer-note">
        No code required. Automatically applied at checkout
        when purchased with your monogram.
      </p>

      <button
        type="button"
        class="lls-offer-close"
      >
        Continue Shopping
      </button>
    `;

    document.body.appendChild(dialog);

    // Close buttons
    const closePopup = () => dialog.close();

    dialog.querySelector('.lls-offer-close')
      .addEventListener('click', closePopup);

    dialog.querySelector('.lls-offer-x')
      .addEventListener('click', closePopup);

    // Close when clicking outside the modal
    dialog.addEventListener('click', event => {
      if (event.target === dialog) closePopup();
    });

    return dialog;
  }

  function handleCartUpdate(event) {
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const data = event.detail?.data || {};

    if (data.didError) return;
    if (data.source !== 'product-form-component') return;

    const productId = String(data.productId || '');
    if (!productId) return;

    const forms = document.querySelectorAll(
      'product-form-component[data-is-monogram="true"]'
    );

    const isMonogram = Array.from(forms).some(
      form => form.dataset.productId === productId
    );

    if (!isMonogram) return;

    const dialog = createPopup();

    if (!dialog.open) {
      dialog.showModal();
      sessionStorage.setItem(SESSION_KEY, '1');
    }
  }

  document.addEventListener('cart:update', handleCartUpdate);
})();


